import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../../../services/AuthService';
import { AdminRouteProps } from './AdminRoute.model';

const AdminRoute = ({ element }: AdminRouteProps) => {
  const [ready, setReady] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const populateAuthenticationState = async () => {
    const authenticated = await authService.isAuthenticated();
    const user = await authService.getUser();

    const nextIsAdmin = Boolean(authenticated && user && user.isAdmin);
    setReady(true);
    setIsAdmin(nextIsAdmin);
  };

  const authenticationChanged = async () => {
    setReady(false);
    setIsAdmin(false);
    await populateAuthenticationState();
  };

  useEffect(() => {
    const subscription = authService.subscribe(() => authenticationChanged());

    populateAuthenticationState().then();

    return () => {
      authService.unsubscribe(subscription);
    };
  }, []);

  if (!ready) {
    return <div></div>;
  }

  return isAdmin ? element : <Navigate replace to="/" />;
};

export default AdminRoute;
